/** Who answers for the data and how to reach them; shown in both documents. */
export const CONTROLLER_NAME = 'Felipe Fonseca';
export const CONTACT_EMAIL = 'contato@financybr.com';

/** One numbered part of a legal page: paragraphs, then an optional list, then closing paragraphs. */
export interface LegalSection {
  title: string;
  paragraphs?: string[];
  items?: string[];
  after?: string[];
}

/**
 * The privacy policy and the terms are written in Portuguese only: they are
 * the versions that bind, for a service run from Brazil under Brazilian law.
 * `**bold**` marks emphasis.
 */
export interface LegalDocument {
  title: string;
  updated: string;
  intro: string[];
  sections: LegalSection[];
}
